import React, { useContext, useEffect } from 'react';
import { AppContext } from './context/AppContext';
import ReturnHome from './ReturnHome';
import { decrementCounter } from './handleCounters.js';

function EditEventMain(props) {
    const { FLAGS, setFlags, timer, setTimer, running, setRunning, events, setEvents,
        period, setPeriod, counters, setCounters } = useContext(AppContext);

    useEffect(() => {
        // every time I go to the main page, close the popup
        props.hideHamburger();
    }, [])

    function deleteEvent(indexToDelete) {
        console.log("Delete event" + indexToDelete)
        console.log("Delete this event:" + events[indexToDelete])
        console.log("All Events:" + events)
        // delete the event type
        const eventType = events[indexToDelete].eventType

        decrementCounter(eventType, setCounters, counters);
        console.log("deleting event" + eventType)
        setEvents(prevEvents => prevEvents.filter((_, index) => index !== indexToDelete));
    }
    return (
        <div id='EditEventsPage'>
            <h1 className='gridItem' >Edit Events</h1>
            {/* <div className="scrollable-div eventWindow editEventWindow eventGridContainer " id="scrollable-div" > */}
            <div className='eventGridContainer gridItem' scrollable="true">
                {/* Header */}
                <div className='header'></div>
                <div className='header'></div>
                <div className='header'>Time</div>
                <div className='header '>Event Type</div>

                {/* Body - scrollable */}
                {events.map((event, index) => (
                    <React.Fragment key={index}>
                        <button className='eventDeleteButton eventGridItem eventDeleteButton' onClick={() => deleteEvent(index)}>X</button>
                        <div className='eventGridItem '>{event.period}</div>
                        <div className='eventGridItem '>{event.time}</div>
                        <div className='eventGridItem eventDescription'>{event.eventType}</div>
                    </React.Fragment>
                ))}
            </div>
            <div className='gridItem'  >

                <ReturnHome className='gridItem' />
            </div>
        </div >
    );
}

export default EditEventMain;